import React, { useState, useEffect } from "react";
import { GenGet, GenPost } from "state/api";
import MsgAlert from 'Admin/components/MsgAlert';
import SubmitButton from 'Admin/components/SubmitButton';
import CustomSelect from "Admin/components/AdminComponents/CustomSelect";

function Venda() {
    const [formData, setFormData] = useState({
        'modo_pagamento':'dinheiro'
    });
    const [itens, setItens] = useState([]); 
    const [novoItem, setNovoItem] = useState({}); 
    const [msg, setMsg] = useState(null);
    const [loading, setLoading] = useState(false);
    const [profissionalLoockup, setProfissionalLookup] = useState([]);
    const [clienteLoockup, setClienteLookup] = useState([]);
    const [produtoLoockup, setProdutoLookup] = useState([]);
    const [servicoLoockup, setServicoLookup] = useState([]);

    const fields = [
        { name: "cliente_id", label: "Cliente", type: "select", options: [], required: false },
        { name: "cliente_av_nome", label: "Nome Cliente Avulso", type: "text" },
        { name: "cliente_av_tel", label: "Telefone Cliente Avulso", type: "text" },
        { name: "email", label: "E-mail", type: "email" },
        { name: "tipo", label: "Tipo", type: "select", options: [
            { value: "produto", label: "Produto" },
            { value: "servico", label: "Serviço" },
            { value: "avulsa", label: "Avulsa" },
        ], required: true },
        { name: "profissional_id", label: "Profissional", type: "select", options: [], required: false },
        { name: "modo_pagamento", label: "Modo de Pagamento", type: "text", required: true },
        { name: "observacoes", label: "Observações", type: "textarea" },
    ];

    const itemFields = [
        { name: "servico_produto_id", label: "Produto/Serviço", type: "select", options: [], required: true },
        { name: "quantidade", label: "Quantidade", type: "number", step: "0.01", required: true },
        { name: "preco_unitario", label: "Preço Unitário", type: "number", step: "0.01", required: true },
    ];

    const handleLookup = async (endpoint, setter) => {
        try {
        const response = await GenGet(endpoint);
        setter(response)

        } catch (err) {
        setMsg("Erro ao bucar Lookups");    
        setTimeout(() => setMsg(null), 3000);
        }
    };

    useEffect(() => {
        Promise.all([
        handleLookup('/profissionais/lookup', setProfissionalLookup),
        handleLookup('/clientes/lookup', setClienteLookup),
        handleLookup('/produtos/lookup', setProdutoLookup),
        handleLookup('/servicos/lookup', setServicoLookup),
        ]).then(() => setLoading(false)); 

    }, []);

    const handleFieldChange = (e) => {
        if (e.target.type === "checkbox") {
            setFormData({ ...formData, [e.target.name]: e.target.checked ? 1 : 0 });
            return;
        }
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handleNovoItemChange = (e) => {
        setNovoItem({ ...novoItem, [e.target.name]: e.target.value });
    };


    //Apenas um item do mesmo tipo
    const adicionarItem = () => {
        if (!novoItem.servico_produto_id || !novoItem.quantidade) {
            setMsg("Preencha todos os campos do item.");
            setTimeout(() => setMsg(null), 3000);
            return;
        }

        setItens([...itens, novoItem]); 
        setNovoItem({});
    };

    const removerItem = (index) => {
        const novosItens = itens.filter((_, i) => i !== index); // Remove o item pelo índice
        setItens(novosItens);
    };

    const handleSubmit = async () => {
        //novavenda
        
        const requiredFields = fields.filter((field) => field.required);
        for (const field of requiredFields) {
            
            if (!formData[field.name]) {
                setMsg(`O campo "${field.label}" é obrigatório`);
                setTimeout(() => setMsg(null), 3000);
                
                return;
            }
        }

        if (itens.length === 0) {
            setMsg("Adicione pelo menos um item à venda.");
            setTimeout(() => setMsg(null), 3000);
            return;
        }

        try {
            setLoading(true);
            const payload = { ...formData, itens };
            const response = await GenPost('/novavenda', payload);

            setMsg(response.message);
            setTimeout(() => setMsg(null), 3000);
            setLoading(false);
            setFormData({});
            setItens([]);

        } catch (err) {
            setMsg(err.message);
            setTimeout(() => setMsg(null), 3000);
            setLoading(false);
        }
    };
  
    return (
      <div className="flex flex-col w-full p-2 text-[10pt] bg-slate-100 rounded-lg shadow-md">
        {/* Cabeçalho */}
        <div className="flex w-full sticky -top-6 bg-slate-100 z-20 flex-col">
          <h3 className="text-[14pt]">Cadastro de Venda</h3>
          <p className="text-[9pt] -mt-2">Preencha as informações da venda</p>
          <hr />
        </div>
  
        {/* Campos do Formulário */}
        <div className="flex flex-wrap gap-1 my-2">
            <div className="flex flex-col gap-1 w-full md:w-[calc(33%-2rem)]">
                <label className="font-semibold">
                    Tipo
                    <span className="text-red-500"> *</span>
                </label>
                <select
                    name={'tipo'}
                    value={formData.tipo || ""}
                    onChange={handleFieldChange}
                    className="px-2 py-2 rounded border border-gray-300 focus:outline-none"
                    >
                    
                    <option key={1} value={'produto'}>
                        Produto
                    </option>
                    <option key={2} value={'servico'}>
                        Serviço
                    </option>
                    <option key={3} value={'avulsa'}>
                        Avulsa
                    </option>
                </select>
            </div>

            {formData.tipo !== 'avulsa' && ( 
                <div className="flex flex-col gap-1 w-full md:w-[calc(33%-2rem)]">
                    <label className="font-semibold">
                        Cliente
                    </label>
                    <CustomSelect
                        name={"cliente_id"}
                        label={"Cliente"}
                        data={clienteLoockup}
                        value={formData.cliente_id || ""}
                        onChange={handleFieldChange}
                        search={true}
                    />
                </div>
            )}

            {formData.tipo === 'avulsa' && (
                <div className="flex flex-col gap-1 w-full md:w-[calc(33%-2rem)]">
                <label className="font-semibold">
                    Nome do Cliente
                </label>
                <input
                    type={'text'}
                    name={'cliente_av_tel'}
                    value={formData.cliente_av_tel || ""}
                    onChange={handleFieldChange}
                    placeholder={'telefone do cliente avulso'}
                    className="px-2 py-1 rounded border border-gray-300 focus:outline-none"
                    />
                </div>
            )}
            {formData.tipo === 'avulsa' && (
                <div className="flex flex-col gap-1 w-full md:w-[calc(33%-2rem)]">
                <label className="font-semibold">
                    Telefone do Cliente
                </label>
                <input
                    type={'text'}
                    name={'cliente_av_nome'}
                    value={formData.cliente_av_nome || ""}
                    onChange={handleFieldChange}
                    placeholder={'nome do cliente avulso'}
                    className="px-2 py-1 rounded border border-gray-300 focus:outline-none"
                    />
                </div>
            )}
            {formData.tipo === 'avulsa' && (
                <div className="flex flex-col gap-1 w-full md:w-[calc(33%-2rem)]">
                <label className="font-semibold">
                    Email
                </label>
                <input
                    type={'text'}
                    name={'email'}
                    value={formData.email || ""}
                    onChange={handleFieldChange}
                    placeholder={'email do cliente'}
                    className="px-2 py-1 rounded border border-gray-300 focus:outline-none"
                    />
                </div>
            )}
            {formData.tipo === 'servico' && (
                <div className="flex flex-col gap-1 w-full md:w-[calc(33%-2rem)]">
                    <label className="font-semibold">
                        Profissional
                    </label>
                    <CustomSelect
                        name={"profissional_id"}
                        label={"Profissional"}
                        data={profissionalLoockup}
                        value={formData.profissional_id || ""}
                        onChange={handleFieldChange}
                        search={true}
                    />
                </div>
            )}

            <div className="flex flex-col gap-1 w-full md:w-[calc(33%-2rem)]">
                    <label className="font-semibold">
                        Modo de pagamento
                        <span className="text-red-500"> *</span>
                    </label>
                    <select
                        name={'modo_pagamento'}
                        value={formData.modo_pagamento || ""}
                        onChange={handleFieldChange}
                        className="px-2 py-1 rounded border border-gray-300 focus:outline-none"
                        >
                        
                        <option key={1} value={'dinheiro'}>
                            Dinheiro
                        </option>
                        <option key={2} value={'pix'}>
                            Pix
                        </option>
                        <option key={3} value={'cartão'}>
                            Cartão
                        </option>
                    </select>
                </div>
            <div className="flex flex-col gap-1 w-full md:w-[calc(33%-2rem)]">
                <label className="font-semibold">
                   Observações
                </label>
                <textarea
                    name={'observacoes'}
                    value={formData.observacoes || ""}
                    onChange={handleFieldChange}
                    placeholder={'observacoes'}
                    className="px-2 py-1 rounded border border-gray-300 focus:outline-none"
                />
            </div>
        </div>

        {/* Campos dos Itens */}
        <div className="mt-4  p-4 border rounded-md ">
                <h4 className="text-[12pt] font-semibold">Itens da Venda</h4>
                <div className="flex flex-wrap gap-2  p-4 border rounded-md bg-white">
                    {itens.map((item, index) => (
                        <div key={index} className="flex items-center p-2 bg-slate-100 rounded-lg shadow-sm">
                            <span className="mr-2">{item.servico_produto_id} - {item.quantidade}x R${item.preco_unitario}</span>
                            <button
                                onClick={() => removerItem(index)}
                                className="text-red-500 hover:text-red-700"
                            >
                                Remover
                            </button>
                        </div>
                    ))}
                </div>

                {/* Formulário para adicionar novo item */}
                <div className="mt-4">
                    <h4 className="text-[12pt] font-semibold">Adicionar Item</h4>
                    <div className="flex flex-wrap gap-2">
                        {formData.tipo === 'servico' ? (
                             <div className="flex flex-col gap-1 w-full md:w-[calc(33%-2rem)]">
                                <label className="font-semibold">Serviço</label>
                                <CustomSelect
                                    name={"servico_produto_id"}
                                    label={"Serviço"}
                                    data={servicoLoockup}
                                    value={novoItem.servico_produto_id}
                                    onChange={handleNovoItemChange}
                                    search={true}
                                />
                             </div>

                        ) : (
                            <div className="flex flex-col gap-1 w-full md:w-[calc(33%-2rem)]">
                                <label className="font-semibold">Produto</label>
                                <CustomSelect
                                    name={"servico_produto_id"}
                                    label={"Produto"}
                                    data={produtoLoockup}
                                    value={novoItem.servico_produto_id}
                                    onChange={handleNovoItemChange}
                                    search={true}
                                />
                            </div>

                        )}

                        <div className="flex flex-col gap-1 w-full md:w-[calc(33%-2rem)]">
                            <label className="font-semibold">Quantidade</label>
                            <input
                                type="number"
                                name="quantidade"
                                value={novoItem.quantidade || ""}
                                onChange={handleNovoItemChange}
                                className="px-2 py-1 rounded border border-gray-300 focus:outline-none"
                            />
                        </div>

                        <div className="flex items-end">
                            <button
                                onClick={adicionarItem}
                                className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
                            >
                                Adicionar Item
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
        {/* Botão de Envio */}
        <SubmitButton loading={loading} onClick={handleSubmit} label="Cadastrar" />
  
        {/* Mensagem de Feedback */}
        <MsgAlert alert={msg} />
      </div>
    );
  }

export default Venda